import smoothScrollTo from './smoothScrollTo';

/**
 * Returns a callback to handle anchor links and
 * adds a smooth scrolling animation to it's target.
 * @return {Function} A callback function
 */
const handleAnchorLink = () => (e) => {
    const hashIndex = $(e.currentTarget).attr('href').indexOf('#');
    const id = $(e.currentTarget).attr('href').substr(hashIndex);
    if ($(id).length) {
        e.preventDefault();
        smoothScrollTo(id);
    }
};

export default handleAnchorLink;



// WEBPACK FOOTER //
// ./src/scripts/components/global/handleAnchorLink.js